import './App.css';
import AboutUs from './views/AboutUs';
import ContactUs from './views/ContactUs';
import Footer from './views/Footer/Footer';
import Header from './views/Header/Header';
import Home from './views/Home';
import ScrollToTopButton from './views/ScrollToTopButton';
import { Routes, Route } from 'react-router-dom';
import Solutions from './views/Solutions';
import IPChart from './views/Technical/IPChart';
import PanelFormation from './views/Technical/PanelFormation';
import LightningProtection from './views/Products/LightingProtection';
import BusbarSystem from './views/Products/BusbarSystem';
import ACDistributionBox from './views/Products/SolarProducts/ACDistributionBox';
import DCDistributionBox from './views/Products/SolarProducts/DCDistributionBox';
import ACCombinerBox from './views/Products/SolarProducts/ACCombinerBox';
import MainDistributionBox from './views/Products/PowerDistribution/MainDistributionBox';
import APFCPannel from './views/Products/PowerDistribution/APFC';
import AutoChangeoverPanel from './views/Products/PowerDistribution/AutoChangeOverPanel';
import MCCPanel from './views/Products/PowerDistribution/MCCPanel';
import VFDSoftStarterPanel from './views/Products/PowerDistribution/VFDSoftStarterPanel';
import SynchronizingPanel from './views/Products/PowerDistribution/SynchronizingPanel';
import { Toaster } from 'react-hot-toast';
import HTSwitchgear from './views/Products/PowerDistribution/HTSwitchgear';
import LoadBreakSwitch from './views/Products/PowerDistribution/LoadBreakSwitch';
import LTSwitchgear from './views/Products/PowerDistribution/LTSwitchgear';
import ATSPanel from './views/Products/PowerDistribution/ATSPanel';
import HTLTAVR from './views/Products/PowerDistribution/HTLTAVR';
import SolarProductSystem from './views/Products/SolarProductSystem';
import BatteryBank from './views/Products/BatteryBank';
import RingMainUNit from './views/Products/PowerDistribution/RingMainUNit';
import PowerDistribution from './views/Products/PowerDistribution/PowerDistribution';
import SubstationOverview from './views/Products/SubstationOverview';

function App() {
  return (
    <div className="App">
      <Header />
      <main className='main'>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/ip-chart" element={<IPChart />} />
          <Route path="/panel-formation" element={<PanelFormation />} />
          <Route path="/lighting-protection" element={<LightningProtection />} />
          <Route path="/busbar-truncking" element={<BusbarSystem />} />
          {/* <Route path="/ac-distribution-box" element={<ACDistributionBox />} />
          <Route path="/dc-distribution-box" element={<DCDistributionBox />} />
          <Route path="/ac-combiner-box" element={<ACCombinerBox />} /> */}
          {/* <Route path="/main-distribution-box" element={<MainDistributionBox />} /> */}
          <Route path="/apfc" element={<APFCPannel />} />
          <Route path="/auto-chnage-over-panel" element={<AutoChangeoverPanel />} />
          <Route path="/mcc-panel" element={<MCCPanel />} />
          <Route path="/vfd-soft-starter-panel" element={<VFDSoftStarterPanel />} />
          <Route path="/synchronizing-panel" element={<SynchronizingPanel />} />
          <Route path="/ht-switcher" element={<HTSwitchgear />} />
          <Route path="/load-break-switch" element={<LoadBreakSwitch />} />
          <Route path="/lt-switchgear" element={<LTSwitchgear />} />
          <Route path="/ats-panel" element={<ATSPanel />} />
          <Route path="/ht-lt-avr" element={<HTLTAVR />} />
          <Route path="/solar-product-system" element={<SolarProductSystem />} />
          <Route path="/battery-bank" element={<BatteryBank />} />
          <Route path="/ring-main-unit" element={<RingMainUNit />} />
          <Route path="/power-distribution" element={<PowerDistribution />} />
          <Route path="/substation-overview" element={<SubstationOverview />} />
        </Routes>
      </main>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            style: {
              background: 'green',
            },
          },
          error: {
            style: {
              background: 'red',
            },
          },
        }}
      />

      <Footer />
      <ScrollToTopButton />
       
    </div>
  );
}

export default App;
